import { styled } from '../../../../theme';

export const SwapRowsCellContainer = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  justifyContent: 'center',
}));
